import React from 'react'

const ChevLeftIcon = (props) => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <mask id='mask0_64_2065' style={{ maskType: 'alpha' }} maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='24'>
      <rect y='24' width='24' height='24' transform='rotate(-90 0 24)' fill='#D9D9D9' />
    </mask>
    <g mask='url(#mask0_64_2065)'>
      <path d='M10.8 12L15.4 16.6L14 18L8 12L14 6L15.4 7.4L10.8 12Z' fill='#33354D' />
    </g>
  </svg>
)

export default ChevLeftIcon
